import cx from 'classnames';
import { defineMessages, FormattedMessage, useIntl } from 'react-intl';

import CopyLinkButton from '../CopyLinkButton';

const messages = defineMessages({
  share_on: {
    id: 'Share on',
    defaultMessage: 'Share on',
  },
});

const SocialShare = ({ url, className }) => {
  const intl = useIntl();

  const socialLinks = [
    {
      name: 'Whatsapp',
      url: 'https://api.whatsapp.com/send?text=',
      icon: 'fa-brands fa-whatsapp',
    },
    {
      name: 'X',
      url: 'https://twitter.com/share?url=',
      icon: 'fa-brands fa-x-twitter',
    },
    {
      name: 'Facebook',
      url: 'http://www.facebook.com/sharer.php?u=',
      icon: 'fa-brands fa-facebook-f',
    },
    {
      name: 'Linkedin',
      url: 'https://linkedin.com/shareArticle/?url=',
      icon: 'fa-brands fa-linkedin-in',
    },
  ];

  return (
    <div
      className={cx(
        'd-flex flex-column flex-sm-row align-items-center',
        className,
      )}
    >
      <span className="mr-half text-down-01">
        <FormattedMessage id="Share" defaultMessage="Share" />:
      </span>

      <div className="d-flex align-items-center">
        {socialLinks.map((link) => (
          <a
            key={link.name}
            href={`${link.url}${url}`}
            target="_blank"
            rel="noopener noreferrer"
            className="br-button circle small"
            title={`${intl.formatMessage(messages.share_on)} ${link.name}`}
            aria-label={`${intl.formatMessage(messages.share_on)} ${link.name}`}
          >
            <span className={link.icon} aria-hidden="true" />
          </a>
        ))}

        <CopyLinkButton url={url} />
      </div>
    </div>
  );
};

export default SocialShare;
